import { render, staticRenderFns } from "./MapIconManorKuncovo.vue?vue&type=template&id=48caf471&scoped=true&"
import script from "./MapIconManorKuncovo.vue?vue&type=script&lang=js&"
export * from "./MapIconManorKuncovo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48caf471",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48caf471')) {
      api.createRecord('48caf471', component.options)
    } else {
      api.reload('48caf471', component.options)
    }
    module.hot.accept("./MapIconManorKuncovo.vue?vue&type=template&id=48caf471&scoped=true&", function () {
      api.rerender('48caf471', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconManorKuncovo.vue"
export default component.exports